import styled from 'styles/styled-components';

export const Content = styled.div`
  position: relative;
  flex: 1;
`;

export default Content;
